// SAP sync removed — stub to prevent downstream breakage
export default {
  namespaced: true,
  state: () => ({
    syncing: false,
    lastSummaries: { items: null, debtors: null, stockQty: null },
    error: null,
  }),
  getters: {},
  mutations: {
    setSyncing(s, v) { s.syncing = !!v; },
    setSummary(s, { resource, summary }) { s.lastSummaries[resource] = summary || null; },
    setError(s, e) { s.error = e || null; },
  },
  actions: {
    syncItems() { return Promise.resolve(); },
    syncDebtors() { return Promise.resolve(); },
    syncStockQty() { return Promise.resolve(); },
  },
};